"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileIcon = void 0;
var _image = require("../../common/image.utils");
var DEFAULT_ICON_URL = '//res.cloudinary.com/honeybook/image/upload/v1502008386/system_web/rebranding/file-default.svg';
var EXCEL_ICON_URL = '//res.cloudinary.com/honeybook/image/upload/v1501764251/system_web/rebranding/file_icon_xls.svg';
var DOC_ICON_URL = '//res.cloudinary.com/honeybook/image/upload/v1501764251/system_web/rebranding/file_icon_doc.svg';
var PDF_ICON_URL = '//res.cloudinary.com/honeybook/image/upload/v1501764252/system_web/rebranding/file_icon_pdf.svg';
var getFileIcon = exports.getFileIcon = function getFileIcon(_ref) {
  var name = _ref.name,
    type = _ref.type,
    url = _ref.url;
  var iconUrl = DEFAULT_ICON_URL;
  var safeType = type || '';
  if (!name) {
    return iconUrl;
  }
  if (name.match(/xlsx?$/) || safeType.match(/xlsx?$/)) {
    iconUrl = EXCEL_ICON_URL;
  } else if (name.match(/docx?$/) || safeType.match(/docx?$/)) {
    iconUrl = DOC_ICON_URL;
  } else if (url && (name.match(/pdf$/) || safeType.match(/pdf$/))) {
    if (url) {
      iconUrl = (0, _image.generatePdfThumbnailUrl)({
        url: url,
        width: 100,
        height: 58
      });
    } else {
      iconUrl = PDF_ICON_URL;
    }
  }
  return iconUrl;
};
//# sourceMappingURL=getFileIcon.js.map